import hasDeliveryChannelExternal from './has-delivery-channel-external';

const isMessageRecipient = (participant) => (
  hasDeliveryChannelExternal(participant)
);

export default isMessageRecipient;
